module.exports = __webpack_public_path__ + "img/partner-banner-bg.ffa50ae2.png";